// Libraries
import { createReactEditorJS } from 'react-editor-js';
import { OutputData } from '@editorjs/editorjs';
import { useTranslation } from 'react-i18next';
import { EDITOR_TOOLS } from './EditorTools';
import { generateRandomSymbols } from '../../common/helpers/RandomGenerator';

export interface EditorProps {
    data: OutputData | undefined;
    setEditor: (editor: any) => void; // editorcore
}

export default function Editor(props: EditorProps) {
    const { t } = useTranslation(['AnelmaContent']);

    const ReactEditorJs = createReactEditorJS();
    var id = 'editor' + generateRandomSymbols(10);

    return (
        <div id={id} className='an-content-editor'>
            <ReactEditorJs
                holder={id}
                // default value for initialisation
                defaultValue={props.data}
                /* value for later updates.
                do not use, has a bug duplicating the content.
                use manual rendering for changes,
                example: ContentEditor.tsx, editorFi.render(outFi) */
                // value={props.data}
                onInitialize={(instance) => props.setEditor(instance)}
                placeholder={t('AnelmaContent:1030') as string}
                tools={EDITOR_TOOLS}
            />
        </div>
    );
}
